import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import { ProductListDto } from './product.schema';

// import { SLICE_BASE_NAME } from '../auth/constant';

export interface ProductStateDto {
  products: ProductListDto;
  page: number;
  limit: number;
  search: string;
  brand_id: string;
}

const initialState: ProductStateDto = {
  products: {
    message: '',
    data: [],
    pagination: {},
  } as ProductListDto,
  page: 1,
  limit: 10,
  search: '',
  brand_id: '',
};

const productSlice = createSlice({
  name: `products`,
  initialState,

  reducers: {
    setProducts(state, action: PayloadAction<ProductListDto>) {
      state.products = action.payload;
    },
    setProductFilters: (state, action) => {
      return { ...state, ...action.payload };
    },
    resetProductFilters: () => initialState,
  },
});

export const { setProducts, setProductFilters, resetProductFilters } =
  productSlice.actions;
export default productSlice.reducer;
